import axios from 'axios';
import router from '@/router'; // 引入 Vue Router 实例
import { Message } from 'element-ui'; // 假设你使用了 Element UI 的 Message 组件

// 创建 Axios 实例
const service = axios.create({
  // 1. 基础配置
  baseURL: process.env.VUE_APP_API_BASE_URL || 'api', // API 的 base_url (环境变量或默认值)
  // timeout: 120000, // 请求超时时间 (120秒)
//   headers: {
//     'Content-Type': 'application/json;charset=UTF-8' 
//   }
});

// 2. 请求拦截器
service.interceptors.request.use(
  config => {
    // 判断是否需要 token
    if (config.needAuth) {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } else {
        // 没有 token，跳转登录页
        if (router.currentRoute.path !== '/login') {
          router.push(`/login?redirect=${router.currentRoute.fullPath}`);
        }
        // 直接中断请求
        return Promise.reject(new Error('请先登录'));
      }
    }
    // 不需要 token 的接口，直接发送
    return config;
  },
  error => {
    // 对请求错误做些什么
    console.error('Request Error:', error); // for debug
    // hideLoading(); // 关闭 loading
    return Promise.reject(error);
  }
);

// 3. 响应拦截器
service.interceptors.response.use(
  /**
   * 如果你想要获取诸如 headers 或 status 的信息
   * 请 return  response => response
  */

  /**
   * 通过自定义 code 判断请求状态，这里只是一个例子
   * 你也可以通过 HTTP 状态码判断状态
   */
  response => {
    // hideLoading(); // 关闭 loading

    const res = response.data;

    // 如果响应成功，直接返回数据
    if (response.status === 200) {
      return res;
    }

    // 如果有错误信息，显示错误
    Message({
      message: res.message || res.detail || '请求失败',
      type: 'error',
      duration: 5 * 1000,
      showClose: true
    });

    return Promise.reject(new Error(res.message || res.detail || '请求失败'));
  },
  error => {
    // hideLoading(); // 关闭 loading
    console.error('Response Error:', error); // for debug

    // 处理 HTTP 网络错误
    let message = '';
    const status = error.response && error.response.status;
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      switch (status) {
        case 400: message = error.response.data.detail; break;
        case 401: 
          message = error.response.data.detail; 
          // 这里也可以直接处理跳转登录
          localStorage.removeItem('authToken');
          localStorage.removeItem('isAuthenticated');
          localStorage.removeItem('phone');
          localStorage.removeItem('nickname');
          if (window.vueInstance) {
            window.vueInstance.$root.$emit('auth-change', { isAuthenticated: false });
          }
          if (router.currentRoute.path !== '/login') {
            router.push(`/login?redirect=${router.currentRoute.fullPath}`);
          }
          break;
        case 403: message = '拒绝访问 (403)'; break;
        case 404: message = error.response.data.detail; break;
        case 500: message = '服务器内部错误 (500)'; break;
        case 502: message = '网关错误 (502)'; break;
        case 503: message = '服务不可用 (503)'; break;
        case 504: message = '网关超时 (504)'; break;
      }
    } else if (error.request) {
      // 请求已发出但没有收到响应
      message = '网络超时，请检查网络连接';
    } else {
      // 发送请求时出了点问题
      message = error.message || '请求失败，请稍后重试';
    }
    if (status !== 409) {
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000,
        showClose: true
      });
    }
    return Promise.reject(error);
  }
);

// 4. 导出 Axios 实例
export default service;

// (可选) 封装常用的请求方法
// export function get(url, params) {
//   return service({
//     url: url,
//     method: 'get',
//     params
//   });
// }

// export function post(url, data) {
//   return service({
//     url: url,
//     method: 'post',
//     data
//   });
// }

// ... 其他方法如 put, delete 等 